"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequestID = exports.createFetchRequest = exports.createResponse = exports.TransformBodyToString = void 0;
const utils_1 = require("../../../utils");
const types_1 = require("../../../xhr/types");
const TransformStringToResponseBody = {
    [types_1.MediaType.BLOB]: (baseToConvert) => 
    // TODO: we do not consider other types of blob such as image/jpeg
    new Blob([baseToConvert]),
    [types_1.MediaType.STREAMEVENT]: (baseToConvert) => new Blob([baseToConvert]).stream(),
    // NOTE: Not all types are supported (https://developer.mozilla.org/en-US/docs/Web/API/Response/Response) so JSON must be converted to string.
    [types_1.MediaType.JSON]: (baseToConvert) => baseToConvert,
    [types_1.MediaType.FORMDATA]: (baseToConvert) => {
        const jsonFormData = JSON.parse(baseToConvert);
        const formData = new FormData();
        for (const key in jsonFormData) {
            if (Object.prototype.hasOwnProperty.call(jsonFormData, key)) {
                const value = jsonFormData[key];
                if (value instanceof Object) {
                    const value = JSON.stringify(jsonFormData[key]);
                    const fileData = JSON.parse(value);
                    const file = new File([fileData.content], fileData.fileName);
                    formData.append(key, file, file.name);
                }
                else {
                    formData.append(key, value);
                }
            }
        }
        return formData;
    },
    [types_1.MediaType.FORMURLENCODED]: (baseToConvert) => new URLSearchParams(baseToConvert),
};
const TransformBodyToString = {
    FormData: (baseToConvert) => __awaiter(void 0, void 0, void 0, function* () {
        const convertedFormData = {};
        for (const [key, value] of baseToConvert) {
            if (value instanceof Blob) {
                convertedFormData[key] = JSON.parse(yield TransformBodyToString.File(value));
            }
            else {
                convertedFormData[key] = value;
            }
        }
        return JSON.stringify(convertedFormData);
    }),
    File: (baseToConvert) => __awaiter(void 0, void 0, void 0, function* () {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.addEventListener('load', () => {
                const body = {
                    fileName: baseToConvert.name,
                    content: fileReader.result,
                    // TODO: extract metadata?
                };
                resolve(JSON.stringify(body));
            });
            // TODO: handle load error?
            fileReader.readAsText(baseToConvert);
        });
    }),
    Blob: (baseToConvert) => {
        return baseToConvert.text();
    },
    URLSearchParams: (baseToConvert) => baseToConvert.toString(),
};
exports.TransformBodyToString = TransformBodyToString;
const createRequestID = (method) => `${method}_${(0, utils_1.createUUID)()}`;
exports.createRequestID = createRequestID;
const createFetchRequest = (_a) => __awaiter(void 0, [_a], void 0, function* ({ url, method, body, headers }) {
    const id = createRequestID(method);
    let convertedBody;
    if (body) {
        if (body.constructor.name === 'String') {
            convertedBody = body;
        }
        else {
            convertedBody = yield TransformBodyToString[body.constructor.name](body);
        }
    }
    return {
        id,
        url,
        method: method,
        body: convertedBody,
        bodyType: body === null || body === void 0 ? void 0 : body.constructor.name,
        headers,
    };
});
exports.createFetchRequest = createFetchRequest;
const createResponse = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const { body, status, statusText, headers } = data;
    let contentType = headers['content-type'] || headers['Content-Type'];
    if (!contentType) {
        contentType = types_1.MediaType.JSON;
        console.warn('There is no content-type header in response. Using default json');
    }
    const convertedBody = yield TransformStringToResponseBody[contentType](body);
    const response = new Response(convertedBody || '{}', {
        status,
        statusText,
        headers: new Headers(headers),
    });
    return response;
});
exports.createResponse = createResponse;
//# sourceMappingURL=utils.js.map